module.exports = __webpack_public_path__ + "img/star-christmas.3bd70eb3.svg";